<template>
	<div class="panel  fz_info">
		<div class="panel-hdr bg-primary-500 bg-success-gradient">
			<h2>
                    <span class="icon-stack fs-xxl mr-2">
                        <i class="base base-7 icon-stack-3x opacity-100 color-primary-500"></i>
                        <i class="base base-7 icon-stack-2x opacity-100 color-primary-400"></i>
                        <i class="fal fa-podcast icon-stack-1x opacity-100 color-white fa-spin"></i>
                    </span>
				СКД
			</h2>

			<div class="panel-toolbar">
				<button class="btn btn-panel waves-effect waves-themed" data-action="panel-fullscreen"
						data-toggle="tooltip" data-offset="0,10" data-original-title="Fullscreen"></button>

			</div>
		</div>

		<div class="panel-container">
			<div class="steps_ panel-content" style="min-height: 150px;">
				<b-overlay class="pt-2 pb-2" :show="!is_load">
					<div class="skd" v-if="is_load">
						<div class="uporx_cards" v-if="obj_to_null(this.gw_item.cards)">
							<h4 class="pt-2 pb-2">Картки</h4>
							<ul>
								<li style="clear:both;margin-bottom:12px" v-for="card in this.gw_item.cards">
									<div class="id">GUID : {{ card.card_guid }} <small style="float:right">Назва:
										{{ card.card_name }}</small></div>
									<div>CARD_STATUS<small style="float:right">{{ card.card_status_h }}</small></div>
								</li>
							</ul>
						</div>

						<div class="uporx_cards" v-if="obj_to_null(this.gw_item.acc_rules)">
							<h4 class="pt-2 pb-2">СКД пункти</h4>
							<ul>
								<li style="clear:both;margin-bottom:12px" v-for="rule in this.gw_item.acc_rules">
									<div class="id">Пункт : <small style="float:right">{{ rule.group_name }}</small>
									</div>
									<div><small style="float:right">{{ rule.name }}</small></div>
								</li>
							</ul>
						</div>

						<div class="uporx_cards" v-if="isAccessDoorList">
							<h4 class="pt-2 pb-2">Доступ на в'їзд і виїзд (door_tokens):</h4>
							<ul>
								<li style="clear:both;margin-bottom:12px"
									class="id"
									v-for="door in accessDoorList"
								>
									<div
										class="w-100 d-flex flex-row flex-nowrap align-items-center justify-content-between"
										style="gap: 12px;"
									>
										<div class="d-flex flex-column flex-nowrap">
											<div class="id">TOKEN : {{ door?.token ?? '' }}</div>
											<div class="id">TOKEN_IN : {{ door?.token_in ?? '' }}</div>
											<div class="id">TOKEN_OUT : {{ door?.token_out ?? '' }}</div>
										</div>
										<small>Назва: {{ door?.name ?? '' }}</small>
									</div>
								</li>
								<li style="clear:both;margin-bottom:12px"
									class="id"
								>
									<div
										class="w-100 d-flex flex-row flex-nowrap align-items-center justify-content-between"
										style="gap: 12px;"
									>
										<div class="id">Дата початку дії доступу:</div>
										<small>{{ dateStartAccess }}</small>
									</div>
								</li>
								<li style="clear:both;margin-bottom:12px"
									class="id"
								>
									<div
										class="w-100 d-flex flex-row flex-nowrap align-items-center justify-content-between"
										style="gap: 12px;"
									>
										<div class="id">Дата кінця дії доступу:</div>
										<small>{{ dateStopAccess }}</small>
									</div>
								</li>
								<li style="clear:both;margin-bottom:12px"
									class="id"
								>
									<div class="d-flex flex-row flex-nowrap align-items-center"
										 style="gap: 12px;"
									>
										<div class="id">Коментар:</div>
										<small class="ms-2 ps-2 text-wrap"> {{ commentAccess }} </small>
									</div>
								</li>
							</ul>
						</div>
					</div>
				</b-overlay>

			</div>
		</div>

	</div>

</template>

<script>
export default {
	name: "os_skd",

	props: {
		id: {
			type: Number,
			required: true
		}
	},

	data() {
		return {
			is_load: false,
			gw_item: {
				cards: [],
				acc_rules: []
			},
			accessDoorList: []
		}
	},

	async created() {
		await this.getOsUprox();
		await this.getAccessDoorList();
		this.is_load = true;
	},

	methods: {
		async getAccessDoorList() {
			const accessTokens = this.gw_item?.adv_fields?.door_tokens ?? '';
			const tokenList = accessTokens.split(",")
				.map(item => Number(item.trim()))
				.filter(Boolean);
			await this.getDoorListByTokens(tokenList);
		},
		async getOsUprox() {
			let os_ids = [];
			let self = this;

			os_ids.push(this.id);
			await api.post('/uprox/users', {
				"os_ids": os_ids,
				"search_type": "full",
				'user_atr': [
					'cards'
				]
			}).then(({data}) => {
				if (data.status == "operation_success") {
					self.gw_item = data.data[0];
				} else {
					self.gw_item = {
						cards: [],
						acc_rules: []
					};
				}

			}).catch(err => {
				self.gw_item = {};
				EventBus.$emit('show_toast', {err: err.message + "OS_ID:" + this.id, type: "danger", title: err.name})
			});
		},
		async getDoorListByTokens(tokensList) {
			await api.post('/uprox/doors/tokens', {
				tokens: tokensList
			})
				.then(({data}) => {
					if (data.status == "operation_success") {
						console.log(data?.data ?? [])
						this.accessDoorList = data?.data ?? [];
					} else {
						this.accessDoorList = [];
					}

				}).catch(err => {
					this.accessDoorList = [];
					EventBus.$emit('show_toast', {
						err: err.message + "OS_ID:" + this.id,
						type: "danger",
						title: err.name
					})
				});
		},
	},


	computed: {
		isAccessDoorList() {
			return this.accessDoorList.length > 0;
		},
		dateStartAccess() {
			const dateStart = this.gw_item?.adv_fields?.schedule_start ?? '';
			return dateStart.replace(/-/g, '.');
		},
		dateStopAccess() {
			const dateStop = this.gw_item?.adv_fields?.schedule_stop ?? '';
			return dateStop.replace(/-/g, '.');
		},
		commentAccess() {
			return this.gw_item?.adv_fields?.comment ?? '';
		}
	}
}
</script>

<style scoped>

</style>
